document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.catalog-faq__title').forEach(title => {
        console.log(1)
        title.addEventListener('click', () => {
            console.log(2)
            const item = title.parentElement;
            const content = item.querySelector('.catalog-faq__content');

            content.classList.toggle('active');
        });
    });
})